import TPremiaCard from "@/components/t-premia-card/t-premia-card";
import { ContentStyled, DescriptionStyled, TitleStyled } from "./style-component";
import { useTheme } from "@/contexts/theme-context/useThemeContext";
import IconLockLight from "@/assets/icons/lock-light/lock-light.svg";
import IconLockDark from "@/assets/icons/lock-dark/lock-dark.svg";
import DOMPurify from 'dompurify';
const AlreadyHaveReward = () => {

    const { isDark } = useTheme();
    return (
        <TPremiaCard variant="dark" style={{ padding: '0px', boxSizing: 'border-box' }}>
            <ContentStyled>
            <div style={{ alignSelf: 'stretch', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <img width={"48px"} height={"48px"} src={isDark ? IconLockDark : IconLockLight} alt="lock" />
                <TitleStyled>Ya tienes esta recompensa</TitleStyled>
                <DescriptionStyled dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize('Participa en nuevas misiones para obtener una mayor variedad de beneficios y coleccionables.') }} />
            </div>
            </ContentStyled>
        </TPremiaCard>
    )
};

export default AlreadyHaveReward;